<template>
  <td style="padding: 0 !important;">
    <div class="bidi inCellHeight" :class="setClass()">{{ value  || '-' }}</div>
  </td>
</template>

<script>
export default {
  name: "NumericCell",
  props: ['value', 'ranges', 'classes', 'noColor'],
  methods: {
    setClass () {

      if (this.noColor) return '';
      const value = this.value;
      if (!this.ranges || this.ranges.length === 0 && value !== null) {

        return value > 0 ? 'up' : value < 0 ? 'down' : 'flat';
      }

      const ranges = this.ranges;
      const classes = this.classes;

      if (!value || !ranges?.length || !classes.length) return ''

      for (let i = 0; i < ranges.length; i++) {
        const lower = ranges[i]
        const upper = ranges[i + 1] ?? Infinity
        if (value >= lower && value < upper) {
          return classes[i] || ''
        }
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.bidi {
  unicode-bidi: plaintext;
  direction: ltr;
  text-align: center;
  padding: 7px 10px !important;
}

.active {
  color: var(--textColor);
  transition: all .2s linear;
}

.low {
  background: rgba(245, 158, 11, 0.15) !important;

  &.active {
    @extend .active;
  }
}

.moderate {
  background: rgba(245, 158, 11, 0.25) !important;

  &.active {
    @extend .active;
  }
}

.medium {
  background: rgba(245, 158, 11, 0.4) !important;

  &.active {
    @extend .active;
  }
}

.high {
  background: rgba(245, 158, 11, .7) !important;

  &.active {
    @extend .active;
  }
}

.extreme {
  background: rgba(245, 158, 11, 0.95) !important;

  &.active {
    @extend .active;
  }
}

.up {
  background: var(--opacityGreen);
  color: var(--green);
}

.down {
  background: var(--opacityRed);
  color: var(--red);
}
</style>
